var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td-table',{ref:_vm.gridRef,attrs:{"height":_vm.height,"columns":_vm.columns,"dataSource":_vm.currentValue,"hasIndex":false,"hasPage":false,"hasLoading":false,"hasMutiSelect":_vm.hasMutiSelect},on:{"select":_vm._handleSelect,"select-all":_vm._handleSelectAll}})
}
var staticRenderFns = []

export { render, staticRenderFns }